import { render, staticRenderFns } from "./benchmarkBuilder.vue?vue&type=template&id=74bce3b8&scoped=true"
import script from "./benchmarkBuilder.vue?vue&type=script&lang=js"
export * from "./benchmarkBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bce3b8",
  null
  
)

export default component.exports